/**
 * Componente funcional que renderiza una lista horizontal de etiquetas (tags).
 * * * **Características**:
 * - Utiliza un diseño flexible (`flex-wrap`) para adaptarse a múltiples etiquetas.
 * - Si el arreglo de ítems está vacío o es nulo, el componente no renderiza nada (`null`).
 * - Chips compactos con tokens `--gm-*` (claro/oscuro) e iconos de FontAwesome.
 * * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Array<Object>} [props.items=[]] - Arreglo de objetos que representan las etiquetas.
 * @param {number|string} props.items[].id - Identificador único de la etiqueta para la propiedad `key`.
 * @param {string} props.items[].name - Nombre o texto que se mostrará dentro de la etiqueta.
 * * @returns {JSX.Element|null} Un contenedor con chips de etiquetas o null si no hay datos.
 */
const TagTicketList = ({ items = [] }) => {
  if (!items || items.length === 0) return null

  return (
    <div className="d-flex flex-wrap gap-1">
      {items.map((tag) => (
        <span key={tag.id} className="ttl-chip">
          <i className="fa-solid fa-tag" />
          {tag.name}
        </span>
      ))}
      <style>{`
        .ttl-chip {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 2px 9px;
          font-size: 0.72rem;
          font-weight: 500;
          line-height: 1.5;
          color: var(--gm-text);
          background: var(--gm-surface-2);
          border: 1px solid var(--gm-border);
          border-radius: 99px;
        }
        .ttl-chip i {
          font-size: 0.62rem;
          color: var(--gm-text-faint);
        }
      `}</style>
    </div>
  )
}

export default TagTicketList
